import { useEffect } from 'react';

import { useTableContext } from 'lib/context/TableContext/TableContext';

const HeaderActions = ({ setMotionHeaderButtonProps }) => {
  const ctx = useTableContext();
  const { ModalComponent, newButtonText, setShowModal, title } = ctx;

  useEffect(() => {
    if (!!ModalComponent && !!setMotionHeaderButtonProps) {
      setMotionHeaderButtonProps({
        onClick: () => setShowModal(true),
        text: newButtonText || `New ${title}`
      });
    }

    return () => {
      setMotionHeaderButtonProps(null);
    };
  }, [ModalComponent, setMotionHeaderButtonProps]);

  return null;
};

export default HeaderActions;
